/** @description Типы внутренних ошибок этой библиотеки при работе с баннерами адфокс */
export var EInternalAdfoxBannerErrors = /*#__PURE__*/function (EInternalAdfoxBannerErrors) {
  EInternalAdfoxBannerErrors["JsonParse"] = "jsonParse";
  return EInternalAdfoxBannerErrors;
}({});